<template>

<div id="app">
	<!-- Static navbar -->
  <!-- <nav class="navbar navbar-expand-lg navbar-light bg-light rounded">
		<a class="navbar-brand" href="#">Navbar</a>
		<button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarsExample09" aria-controls="navbarsExample09" aria-expanded="false" aria-label="Toggle navigation">
		  <span class="navbar-toggler-icon"></span>
		</button>

		<div class="collapse navbar-collapse" id="navbarsExample09">
		  <ul class="navbar-nav mr-auto">
				<li><router-link to="/">Home</router-link></li>
				<li><router-link to="/history">History</router-link></li>
		  </ul>
		</div>
	</nav> -->

	<!-- Main component for a primary marketing message or call to action -->
	<div style="height: 100%; display: flex;">
		<router-view></router-view>
	</div>
    
  </div>
</template>
<script type="text/babel">
export default {
  data () {
    return {
}
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue